/** @format */

import { BVPixelEffects, ProductReviewsFilterEffects, ReviewAiProsConsEffects, productReviewReducers } from './+state';

import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { NgModule } from '@angular/core';
import { ProductReviewsResolver } from './resolver/product-reviews.resolver';
import { StoreModule } from '@ngrx/store';

@NgModule({
	imports: [
		CommonModule,
		StoreModule.forFeature('productReviews', productReviewReducers),
		EffectsModule.forFeature([BVPixelEffects, ProductReviewsFilterEffects, ReviewAiProsConsEffects])
	],
	providers: [ProductReviewsResolver],
	exports: [StoreModule]
})
export class ProductReviewsDataAccessModule {}
